import { defineMessages, FormattedMessage } from 'react-intl';

export const myAccountMessages = defineMessages({
  wishlistEmptyText1: {
    defaultMessage: "It looks like you haven't added any items yet.",
    id: 'myAccount.wishlistEmptyText1',
  },
  wishlistEmptyText2: {
    defaultMessage:
      'Start exploring now to find your beloved Breitling and save them for later!',
    id: 'myAccount.wishlistEmptyText2',
  },
  wishlistEmptyText2NotAuthenticated: {
    defaultMessage:
      ' to save your favorite Breitling pieces and access them anytime, anywhere.',
    id: 'myAccount.wishlistEmptyText2NotAuthenticated',
  },
  wishlist: {
    defaultMessage: 'Wishlist',
    id: 'myAccount.wishlist',
  },
  myAccount: {
    defaultMessage: 'My Account',
    id: 'myAccount.myAccount',
  },
  joinTheClub: {
    defaultMessage: 'Join {link} to enjoy more benefits',
    id: 'myAccount.joinBreitlingClub',
  },
  greeting: {
    defaultMessage: 'Hello {firstName}',
    id: 'myAccount.greeting',
  },
  myWatches: {
    defaultMessage: 'My Watches',
    id: 'myAccount.myWatches',
  },
  myWishlist: {
    defaultMessage: 'My Wishlist',
    id: 'myAccount.myWishlist',
  },
  myOrders: {
    defaultMessage: 'My Orders',
    id: 'myAccount.myOrders',
  },
  orderDetail: {
    defaultMessage: 'Order detail',
    id: 'myAccount.orderDetail',
  },
  breitlingTrade: {
    defaultMessage: 'Breitling Trade',
    id: 'myAccount.breitlingTrade',
  },
  breitlingSelect: {
    defaultMessage: '#BreitlingSelect',
    id: 'myAccount.breitlingSelect',
  },
  myDetails: {
    defaultMessage: 'My Details',
    id: 'myAccount.myDetails',
  },
  myPreferences: {
    defaultMessage: 'My Preferences',
    id: 'myAccount.myPreferences',
  },
  menuNewsletter: {
    defaultMessage: 'My Newsletter',
    id: 'account.detailsMenu.newsletter',
  },
  detailsMenuAccount: {
    defaultMessage: 'My Account',
    id: 'account.detailsMenu.account',
  },
  newsletterTitle: {
    defaultMessage: 'My Newsletter',
    id: 'account.newsletter.title',
  },
  newsletterDescription: {
    defaultMessage:
      'Get up to date with what you care about. Select the newsletter you want to receive at',
    id: 'account.newsletter.description',
  },
  newsletterNovelties: {
    defaultMessage: 'Novelties',
    id: 'account.newsletter.novelties',
  },
  newsletterNoveltiesDescription: {
    defaultMessage: 'When new watches are released',
    id: 'account.newsletter.noveltiesDescription',
  },
  newsletterSquad: {
    defaultMessage: 'Squad updates',
    id: 'account.newsletter.squad',
  },
  newsletterSquadDescription: {
    defaultMessage: 'When our squad takes action',
    id: 'account.newsletter.squadDescription',
  },
  newsletterNews: {
    defaultMessage: 'News about breitling',
    id: 'account.newsletter.news',
  },
  newsletterNewsDescription: {
    defaultMessage: 'Once a week',
    id: 'account.newsletter.newsDescription',
  },
  newsletterEvents: {
    defaultMessage: 'Breitling events',
    id: 'account.newsletter.events',
  },
  newsletterEventsDescription: {
    defaultMessage: 'Once a month',
    id: 'account.newsletter.eventsDescription',
  },
  newsletterEditions: {
    defaultMessage: 'Special editions',
    id: 'account.newsletter.editions',
  },
  newsletterEditionsDescription: {
    defaultMessage: 'Twice a year',
    id: 'account.newsletter.editionsDescription',
  },
  newsletterTrade: {
    defaultMessage: 'Breitling trade',
    id: 'account.newsletter.trade',
  },
  newsletterTradeDescription: {
    defaultMessage:
      'When a product similar to a breitling trade favourite is published',
    id: 'account.newsletter.tradeDescription',
  },
  accountTitle: {
    defaultMessage: 'My account',
    id: 'account.account.title',
  },
  accountName: {
    defaultMessage: 'Name',
    id: 'account.account.name',
  },
  accountBirth: {
    defaultMessage: 'Date of birth',
    id: 'account.account.birth',
  },
  accountEmail: {
    defaultMessage: 'E-mail',
    id: 'account.account.email',
  },
  accountPhone: {
    defaultMessage: 'Phone',
    id: 'account.account.phone',
  },
  accountPassword: {
    defaultMessage: 'Password',
    id: 'account.account.password',
  },
  accountChangeCta: {
    defaultMessage: 'Change',
    id: 'account.change.cta',
  },
  accountDetailsMenuAddresses: {
    defaultMessage: 'My Addresses',
    id: 'account.detailsMenu.address',
  },
  myAddresses: {
    defaultMessage: 'My Addresses',
    id: 'myAccount.myAddresses',
  },
  myPreferredBoutique: {
    defaultMessage: 'My Preferred Boutique',
    id: 'account.detailsMenu.boutique',
  },
  myPaymentDetails: {
    defaultMessage: 'My Payment Details',
    id: 'myAccount.myPaymentDetails',
  },
  editPhoneNumber: {
    defaultMessage: 'Edit Phone Number',
    id: 'myAccount.editPhoneNumber',
  },
  editPassword: {
    defaultMessage: 'Edit Password',
    id: 'myAccount.editPassword',
  },
  editMyEmail: {
    defaultMessage: 'Edit My Email',
    id: 'account.account.editMyEmail.title',
  },
  currentPassword: {
    defaultMessage: 'Current password',
    id: 'myAccount.currentPassword',
  },
  newPassword: {
    defaultMessage: 'New password',
    id: 'myAccount.newPassword',
  },
  repeatNewPassword: {
    defaultMessage: 'Repeat new password',
    id: 'myAccount.repeatNewPassword',
  },
  makeSureAboutPassword: {
    defaultMessage: 'Make sure your password is composed of the followings:',
    id: 'myAccount.makeSureAboutPassword',
  },
  atLeastCharacters: {
    defaultMessage: 'At least 10 characters',
    id: 'myAccount.atLeastCharacters',
  },
  atLeastUppercaseLetter: {
    defaultMessage: 'At least 1 uppercase letter',
    id: 'myAccount.atLeastUppercaseLetter',
  },
  atLeastLowercaseLetter: {
    defaultMessage: 'At least 1 lowercase letter',
    id: 'myAccount.atLeastLowercaseLetter',
  },
  atLeastNumber: {
    defaultMessage: 'At least 1 number',
    id: 'myAccount.atLeastNumber',
  },
  atLeastSpecialCharacter: {
    defaultMessage: 'At least 1 special character',
    id: 'myAccount.atLeastSpecialCharacter',
  },
  newEmail: {
    defaultMessage: 'New email',
    id: 'myAccount.newEmail',
  },
  prefix: {
    defaultMessage: 'Prefix',
    id: 'myAccount.prefix',
  },
  editDetails: {
    defaultMessage: 'Edit Details',
    id: 'myAccount.editDetails',
  },
  editMyData: {
    defaultMessage: 'Edit my data',
    id: 'myAccount.editMyData',
  },
  emailHasBeenSent: {
    defaultMessage:
      'Your associated email address is {email}. Enter your new e-mail address below. A verification link will be sent to this new address.',
    id: 'account.account.editMyEmail.description',
  },
  completeRegistration: {
    defaultMessage: 'Complete registration',
    id: 'myAccount.completeRegistration',
  },
  completeRegistrationProvidePassword: {
    defaultMessage:
      'To complete your account registration, please set and confirm your password.',
    id: 'myAccount.completeRegistrationProvidePassword',
  },
  accountAddressTitle: {
    defaultMessage: 'My shipping & billing Addresses',
    id: 'account.address.title',
  },
  accountAddressMobileTitle: {
    defaultMessage: 'My Addresses',
    id: 'account.address.mobile.title',
  },
  accountAddressAddNewAddressCta: {
    defaultMessage: 'Add a new address',
    id: 'address.add.cta',
  },
  accountAddressAddNewAddressPropmt: {
    defaultMessage:
      'You do not have addresses history yet,{br}Add an address for easy checkout.',
    id: 'account.address.addnewaddress.propmt',
  },
  accountAddressPrimaryShipping: {
    defaultMessage: 'Primary shipping address',
    id: 'account.address.primaryShipping',
  },
  accountAddressDefault: {
    defaultMessage: 'Default Address',
    id: 'account.address.default',
  },
  accountAddressPrimaryBilling: {
    defaultMessage: 'Primary billing address',
    id: 'account.address.primaryBilling',
  },
  accountDetailsMenuLogOut: {
    defaultMessage: 'Log out',
    id: 'account.detailsMenu.logOut',
  },
  accountWishlistTitle: {
    defaultMessage: 'My wishlist',
    id: 'account.wishlist.title',
  },
  accountWishlistEmptyTitle: {
    defaultMessage: 'Your wishlist is empty',
    id: 'account.wishlist.emptyTitle',
  },
  accountWishlistEmptyDescription: {
    defaultMessage:
      'to view your wish list anytime, anywhere, on any device! Otherwise, your list will only be available on this device and will expire at the end of this session.',
    id: 'account.wishlist.emptyDescription',
  },
  accountWishlistContinueShoppingCta: {
    defaultMessage: 'Continue shopping',
    id: 'wishlist.continueShopping.cta',
  },
  accountWishlistGoToMyAccountCta: {
    defaultMessage: 'Go to my account',
    id: 'wishlist.goToMyAccount.cta',
  },
  accountOrdersTitle: {
    defaultMessage: 'My orders',
    id: 'account.ordersTitle',
  },
  accountOrdersMenuOngoing: {
    defaultMessage: 'On-going order',
    id: 'account.ordersMenu.ongoing',
  },
  accountOrdersMenuOrderHistory: {
    defaultMessage: 'Order history',
    id: 'account.ordersMenu.orderHistory',
  },
  accountOrdersMenuReturn: {
    defaultMessage: 'Return history',
    id: 'account.ordersMenu.return',
  },
  accountOrdersMenuService: {
    defaultMessage: 'Service history',
    id: 'account.ordersMenu.service',
  },
  accountOrdersMenuTradeIn: {
    defaultMessage: 'Trade-in history',
    id: 'account.ordersMenu.tradeIn',
  },
  accountOrdersMenuLogOut: {
    defaultMessage: 'Log out',
    id: 'account.ordersMenu.logOut',
  },
  accountOngoingTitle: {
    defaultMessage: 'On-going order',
    id: 'account.ongoing.title',
  },
  accountOngoingEmpty: {
    defaultMessage: 'You do not have any order yet.',
    id: 'account.ongoing.empty',
  },
  accountOrdersContinueShoppingCta: {
    defaultMessage: 'Continue shopping',
    id: 'orders.continueShopping.cta',
  },
  accountOrderHistoryTitle: {
    defaultMessage: 'Order history',
    id: 'account.orderHistory.title',
  },
  accountOrderHistoryEmpty: {
    defaultMessage: 'You do not have any completed orders yet.',
    id: 'account.orderHistory.empty',
  },
  accountReturnTitle: {
    defaultMessage: 'Return history',
    id: 'account.return.title',
  },
  accountReturnEmpty: {
    defaultMessage: 'You do not have return history yet.',
    id: 'account.return.empty',
  },
  accountWatchesTitle: {
    defaultMessage: 'My Watches',
    id: 'account.watches.title',
  },
  accountWatchesEmptyDescription: {
    defaultMessage: `Register your watch to access its digital documents, claim your
    blockchain-based digital passport and get access to many exclusive
    services.`,
    id: 'account.watches.emptyDescription',
  },
  accountWatchesRegisterCta: {
    defaultMessage: `Register a new watch`,
    id: 'watches.register.cta',
  },
  accountWatchesBuyCta: {
    defaultMessage: `Buy a watch`,
    id: 'watches.buy.cta',
  },
  accountWatchesEmptyTitle: {
    defaultMessage: `register for more benefits`,
    id: 'account.watches.emptyTitle',
  },
  addNewAddress: {
    defaultMessage: 'Add a new address',
    id: 'myAccount.addNewAddress',
  },
  edit: {
    defaultMessage: 'Edit',
    id: 'myAccount.edit',
  },
  editAddress: {
    defaultMessage: 'Edit address',
    id: 'myAccount.editAddress',
  },
  unauthorizedShippingCountry: {
    defaultMessage: 'Unauthorized shipping country',
    id: 'myAccount.unauthorizedShippingCountry',
  },
  primaryAddressRequired: {
    defaultMessage:
      'A primary address is required. Please designate an alternative address as the primary address.',
    id: `account.address.errors.primaryAddressRequired`,
  },
  verificationLink: {
    defaultMessage: 'A verification link has been sent to',
    id: 'myAccount.verificationLink',
  },
  clickVerificationLink: {
    defaultMessage:
      'Please click on this link in your inbox to validate your new e-mail address.',
    id: 'myAccount.clickVerificationLink',
  },
  continue: {
    defaultMessage: 'continue',
    id: 'myAccount.continue',
  },
  loginError: {
    defaultMessage: 'Email or password is incorrect',
    id: 'myAccount.loginError',
  },
  invalidCredentials: {
    defaultMessage: 'Invalid credentials',
    id: 'myAccount.invalidCredentials',
  },
  accountAlreadyExist: {
    defaultMessage: 'Account already exists.',
    id: 'myAccount.accountAlreadyExist',
  },
  removeWatchForMyAccount: {
    defaultMessage: 'REMOVE FROM MY ACCOUNT',
    id: 'myAccount.removeWatchForMyAccount',
  },
  rememberToOptIn: {
    defaultMessage: 'Remember to opt-in to get the warranty extension',
    id: 'myAccount.rememberToOptIn',
  },
  accountNameKanji: {
    defaultMessage: 'Name (Kanji)',
    id: 'account.account.nameKanji',
  },
  accountNameKatakana: {
    defaultMessage: 'Name (Katakana)',
    id: 'account.account.nameKatakana',
  },
});

export const YourPhoneHasBeenChanged = (
  <FormattedMessage
    defaultMessage='Your phone number has been changed successfully'
    id='myAccount.yourPhoneHasBeenChanged'
  />
);

export const YourEmailHasBeenChanged = (
  <FormattedMessage
    defaultMessage='Your email has been changed successfully'
    id='myAccount.yourEmailHasBeenChanged'
  />
);

export const YourPasswordHasBeenChanged = (
  <FormattedMessage
    defaultMessage='Your password has been changed successfully'
    id='myAccount.yourPasswordHasBeenChanged'
  />
);

export const YourDetailsHaveBeenChanged = (
  <FormattedMessage
    defaultMessage='Your details have been changed successfully'
    id='myAccount.yourDetailsHaveBeenChanged'
  />
);

export const YourAddressHaveBeenChanged = (
  <FormattedMessage
    defaultMessage='Your address have been changed successfully'
    id='myAccount.yourAddressHaveBeenChanged'
  />
);

export const YourAddressHaveBeenDeleted = (
  <FormattedMessage
    defaultMessage='Your address have been deleted successfully'
    id='myAccount.yourAddressHaveBeenDeleted'
  />
);

export const YourAddressHaveBeenAdded = (
  <FormattedMessage
    defaultMessage='Your address have been added successfully'
    id='myAccount.yourAddressHaveBeenAdded'
  />
);

export const YourWatchHaveBeenAdded = (
  <FormattedMessage
    defaultMessage='Watch is added successfully.'
    id='myAccount.yourWatchHaveBeenAdded'
  />
);

export const YourWatchHaveBeenDeleted = (
  <FormattedMessage
    defaultMessage='This serial number has been unbundled from your account.'
    id='myAccount.yourWatchHaveBeenDeleted'
  />
);
